import React from 'react'
import { menuItemClasses } from '@mui/material/MenuItem'
import styled from 'particles/themes/styled'
import { BaseMenuItemProps, MenuItemSize } from '.'
import { StyledBaseMenuItem } from './style'
import { IconName } from 'particles/Icon'
import Dropdown, { DropdownSize } from 'particles/Dropdown'

const sizeMap: Record<MenuItemSize, { dropdownSize: DropdownSize }> = {
    m: {
        dropdownSize: 's',
    },
    s: {
        dropdownSize: 'xs',
    },
}

interface MenuItemProps<T = unknown> extends Omit<BaseMenuItemProps, 'value' | 'onChange'> {
    value?: T
    onChange?: (value?: T) => void
    text?: string
    placeholder?: string
    icon?: IconName
}

const StyledMenuItem = styled(StyledBaseMenuItem)`
    &.${menuItemClasses.root} {
        flex-direction: column;
        align-items: flex-start;
        justify-content: center;
        &:hover,
        ${`&.${menuItemClasses.focusVisible}`}:hover {
            background-color: transparent;
        }
        &.${menuItemClasses.focusVisible} {
            cursor: unset;
            background-color: transparent;
        }
    }
`

const MenuItemDropdown: React.FC<MenuItemProps> = ({
    value,
    isDisabled,
    size = 's',
    onChange,
    text,
    placeholder,
    icon,
    children,
    ...props
}) => {
    const { dropdownSize } = sizeMap[size]
    return (
        <StyledMenuItem {...props} disabled={isDisabled} disableRipple>
            <Dropdown
                label={text}
                placeholder={placeholder}
                size={dropdownSize}
                icon={icon}
                value={value}
                onChange={onChange}
            >
                {children}
            </Dropdown>
        </StyledMenuItem>
    )
}

export default MenuItemDropdown
